import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from 'store';
import { ApiResponse } from 'types/api';
import { ShippingSnapshotDto } from 'types/snapshots/deliveriesSummarySnapshot';
import axiosServices from 'utils/api/axiosServices';

export interface ShippingSnapshotProps {
  isLoading: boolean;
  snapshot: ShippingSnapshotDto | null;
}

const initialState: ShippingSnapshotProps = {
  isLoading: true,
  snapshot: null
};

const slice = createSlice({
  name: 'shippingSnapshot',
  initialState: { ...initialState },
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setSnapshotData(state, action: PayloadAction<ShippingSnapshotDto>) {
      state.snapshot = action.payload;
    }
  }
});

export default slice.reducer;

export function loadShippingSnapshot() {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));

      const response = await axiosServices.get<ApiResponse<ShippingSnapshotDto>>('customer-deliveries/shipping-snapshot');

      dispatch(slice.actions.setSnapshotData(response.data.data));
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(slice.actions.setLoading(false));
    }
  };
}
